module.exports = __webpack_public_path__ + "img/tofusalat-uncutted-background.30cff0a7.jpg";